(function() {
  var StringUtil, jsts;

  App.load('bower::wicket/wicket-leaflet');

  jsts = App.load('bower::jsts/lib/jsts');

  StringUtil = App.load('core::utils/string');

  L.GeoUtil = L.Class.extend({
    statics: {
      rotatePoints: function(center, angle, points) {
        var k, len, point, results, rotatedX, rotatedY;
        angle = angle * (Math.PI / 180);
        console.log(points);
        results = [];
        for (k = 0, len = points.length; k < len; k++) {
          point = points[k];
          rotatedX = Math.cos(angle) * (point.lng - center.lng) - Math.sin(angle) * (point.lat - center.lat) + center.lng;
          rotatedY = Math.sin(angle) * (point.lng - center.lng) + Math.cos(angle) * (point.lat - center.lat) + center.lat;
          point.lng = rotatedX;
          results.push(point.lat = rotatedY);
        }
        return results;
      },
      unnestAdd: function(featuregroup, geom) {
        if (geom instanceof L.LayerGroup) {
          return geom.eachLayer((function(_this) {
            return function(ll) {
              return L.GeoUtil.unnestAdd(featuregroup, ll);
            };
          })(this));
        } else {
          return featuregroup.addLayer(geom);
        }
      },
      multiPolygonize: (function(_this) {
        return function(fc) {
          var addPoly, ft, k, len, multi, ref;
          addPoly = function(dest, ft) {
            var k, len, poly, ref, ref1, ref2, results;
            if (((ref = ft.geometry) != null ? ref.type : void 0) === 'Polygon') {
              return dest.geometry.coordinates.push(ft.geometry.coordinates);
            } else if (((ref1 = ft.geometry) != null ? ref1.type : void 0) === 'MultiPolygon') {
              ref2 = ft.geometry.coordinates;
              results = [];
              for (k = 0, len = ref2.length; k < len; k++) {
                poly = ref2[k];
                results.push(dest.geometry.coordinates.push(poly));
              }
              return results;
            }
          };
          multi = {
            'type': 'Feature',
            'properties': {},
            'geometry': {
              'type': 'MultiPolygon',
              'coordinates': []
            }
          };
          if (fc.type === 'FeatureCollection') {
            ref = fc.features;
            for (k = 0, len = ref.length; k < len; k++) {
              ft = ref[k];
              addPoly(multi, ft);
            }
          } else {
            addPoly(multi, fc);
          }
          return multi;
        };
      })(this),
      combine: function(geom1, geom2, operation, extra_args) {
        var args, e, geom1_j, geom2_j, result;
        if (extra_args == null) {
          extra_args = [];
        }
        if (!operation) {
          throw new TypeError('A combine operation must be specified');
        }
        geom1_j = L.GeoUtil.readToJSTS(geom1);
        geom2_j = L.GeoUtil.readToJSTS(geom2);
        if (geom1_j[operation] == null) {
          throw new ReferenceError(operation + " is not a valid JSTS operation");
        }
        args = [geom2_j].concat(extra_args);
        try {
          result = geom1_j[operation].apply(geom1_j, args);
        } catch (error) {
          e = error;
          console.log(e);
          return geom1_j;
        }
        return result;
      },
      prune: function(geom) {
        var angle, i, ind, j, k, len, len1, ll2, ll3, m, pt1, pt2, pt3, pts_remove, ref;
        if (geom instanceof L.FeatureGroup) {
          return geom.eachLayer(function(l) {
            return L.GeoUtil.prune(l);
          });
        } else if ((geom._latlngs != null) && geom._latlngs.length > 3) {
          pts_remove = [];
          ref = geom._latlngs;
          for (j = k = 0, len = ref.length; k < len; j = ++k) {
            i = ref[j];
            pt1 = new jsts.geom.Coordinate(i.lng, i.lat);
            ll2 = geom._latlngs[j + 1];
            ll3 = geom._latlngs[j + 2];
            if (ll2 == null) {
              ll2 = geom._latlngs[0];
              ll3 = geom._latlngs[1];
            } else if (ll3 == null) {
              ll3 = geom._latlngs[0];
            }
            pt2 = new jsts.geom.Coordinate(ll2.lng, ll2.lat);
            pt3 = new jsts.geom.Coordinate(ll3.lng, ll3.lat);
            angle = jsts.algorithm.Angle.angleBetween(pt1, pt2, pt3);
            if ((angle * L.LatLng.RAD_TO_DEG) < 2) {
              pts_remove.push(ll2);
            }
          }
          for (m = 0, len1 = pts_remove.length; m < len1; m++) {
            i = pts_remove[m];
            ind = geom._latlngs.indexOf(i);
            if (ind !== -1) {
              geom._latlngs.splice(ind, 1);
            }
          }
          return geom.redraw();
        }
      },
      prune2: function(geom) {
        var gg;
        gg = L.GeoUtil.readToJSTS(geom);
        geom = L.GeoUtil._cleanJstsPolygon(gg);
        return geom;
      },
      _cleanJstsPolygon: function(poly) {
        var i, k, len, len1, m, ngeom, ref, ref1;
        if (!poly.isValid()) {
          if (poly instanceof jsts.geom.Polygon) {
            ngeom = new jsts.geom.Polygon(poly.shell);
            ref = poly.holes;
            for (k = 0, len = ref.length; k < len; k++) {
              i = ref[k];
              ngeom = L.GeoUtil.combine(ngeom, new jsts.geom.Polygon(i), 'difference');
            }
            return ngeom;
          } else if (poly instanceof jsts.geom.MultiPolygon) {
            ngeom = new jsts.geom.MultiPolygon([]);
            ref1 = poly.geometries;
            for (m = 0, len1 = ref1.length; m < len1; m++) {
              i = ref1[m];
              ngeom.geometries.push(L.GeoUtil._cleanJstsPolygon(i));
            }
            return ngeom;
          }
        } else {
          return poly;
        }
      },

      /*
      tris: (geom) ->
          gg = L.GeoUtil.readToJSTS(geom)
      
          tr = new jsts.triangulate.DelaunayTriangulationBuilder()
          tr.setSitesFromGeometry(gg)
      
          return tr.getTriangles(gg.getFactory())
       */
      dedupPoints: function(geom) {
        var array, i, ind, k, len, results;
        if (geom instanceof L.FeatureGroup) {
          return geom.eachLayer(function(l) {
            return L.GeoUtil.dedupPoints(l);
          });
        } else if (geom._latlngs != null) {
          array = geom._latlngs.slice(0);
          results = [];
          for (ind = k = 0, len = array.length; k < len; ind = ++k) {
            i = array[ind];
            if (ind === 0) {
              continue;
            }
            if (array[ind - 1].toString() === array[ind].toString()) {
              results.push(geom._latlngs.splice(geom._latlngs.indexOf(i), 1));
            } else {
              results.push(void 0);
            }
          }
          return results;
        }
      },
      copyGeometry: function(geom) {
        var w, wkt;
        wkt = new Wkt.Wkt();
        w = wkt.fromObject(geom);
        return wkt.toObject(w);
      },
      cloneGeometry: function(geom) {
        return $.extend(true, {}, geom);
      },
      readToJSTS: function(feature) {
        var group, reader, w, wkt;
        if ((feature.CLASS_NAME != null) && (typeof feature.CLASS_NAME === 'string') && StringUtil.startsWith(feature.CLASS_NAME, 'jsts')) {
          return feature;
        }
        if (feature.getLayers != null) {
          group = L.featureGroup();
          L.GeoUtil.unnestAdd(group, feature);
          feature = group;
        }
        wkt = new Wkt.Wkt();
        w = wkt.fromObject(feature);
        reader = new jsts.io.WKTReader();
        return reader.read(w.write());
      },
      readFromJSTS: function(geometry, options) {
        var writer;
        if (options == null) {
          options = {};
        }
        if ((geometry.CLASS_NAME != null) && StringUtil.startsWith(geometry.CLASS_NAME, 'jsts')) {
          writer = new jsts.io.GeoJSONWriter();
          return new L.GeoJSON(writer.write(geometry), options);
        }
        return geometry;
      },
      safeBuffer: function(geom, bufferfactor) {
        var i, k, len, ref;
        geom = L.GeoUtil.readToJSTS(geom);
        if (geom instanceof jsts.geom.MultiPolygon) {
          if (geom.geometries != null) {
            ref = geom.geometries;
            for (k = 0, len = ref.length; k < len; k++) {
              i = ref[k];
              i = i.buffer(bufferfactor);
            }
          }
        } else {
          geom = geom.buffer(bufferfactor);
        }
        return geom;
      },
      setNestedStyles: function(fg, style) {
        if ($.isFunction(style)) {
          style = style(fg);
        }
        return fg.eachLayer(function(l) {
          var newstyle;
          if (l instanceof L.LayerGroup) {
            return L.GeoUtil.setNestedStyles(l, style);
          } else if (l.setStyle != null) {
            if ($.isFunction(style)) {
              newstyle = style(l);
            } else {
              newstyle = style;
            }
            return l.setStyle(newstyle);
          }
        });
      },
      getAcreage: function(poly) {
        var acreages, east, geom, south;
        poly = L.GeoUtil.readFromJSTS(poly);
        if (poly instanceof L.FeatureGroup) {
          acreages = [];
          poly.eachLayer(function(l) {
            return acreages.push(L.GeoUtil.getAcreage(l));
          });
          return acreages;
        }
        south = poly.getBounds().getSouth();
        east = poly.getBounds().getEast();
        if (poly.cloneGeom == null) {
          return;
        }
        poly = poly.cloneGeom();
        poly.eachPoint(function(index, point) {
          var lat, lng;
          lat = point.distanceTo([south, point.lng]);
          lng = point.distanceTo([point.lat, east]);
          point.lat = lat;
          return point.lng = lng;
        });
        geom = L.GeoUtil.readToJSTS(poly);
        if (!App.is_metric) {
          return geom.getArea() * 0.000247105;
        } else {
          return geom.getArea() * 0.0001;
        }
      },
      getSumAcreage: function(group) {
        var acres, sum;
        sum = function(acc, x) {
          var i, k, len;
          if ($.isArray(x)) {
            for (k = 0, len = x.length; k < len; k++) {
              i = x[k];
              acc += sum(0, i);
            }
          } else {
            acc += parseFloat(x);
          }
          return acc;
        };
        acres = L.GeoUtil.getAcreage(group);
        if ($.isArray(acres)) {
          acres = List.foldl(sum, 0, acres);
        }
        return acres;
      },
      getHoleAcreage: function(poly, hole_id) {
        var ll;
        ll = poly._holes[hole_id];
        return L.GeoUtil.getAcreage(new L.Polygon(ll));
      }
    }
  });

}).call(this);
